import React from 'react';
import classNames from 'classnames';
import { SetupForm } from './SetupForm/SetupForm';

import css from './GoogleAds.module.css';
import { SlideoutMenu } from '../../../../components/SlideoutMenu/components/SlideoutMenu';
import { useSlideoutOnClose } from '../../../../components/SlideoutMenu/menus/SlideoutEmail/SlideoutEmail';

type Props = {
  className?: string;
};

export const GoogleAds = ({ className }: Props) => {
  const containerClassName = classNames(className, css.menu);

  const { setRef } = useSlideoutOnClose();

  return (
    <SlideoutMenu className={containerClassName} setRef={setRef}>
      <SlideoutMenu.Content className={css.content}>
        <SetupForm />
      </SlideoutMenu.Content>
    </SlideoutMenu>
  );
};
